import { render, staticRenderFns } from "./admissionsCost.vue?vue&type=template&id=248e893e"
import script from "./admissionsCost.vue?vue&type=script&lang=js"
export * from "./admissionsCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports